module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.ybordersData,
      "height": _vm.wheight - 500
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sku_id",
      "label": "商品ID",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sku_bn",
      "label": "商品货号",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sku_name",
      "label": "商品名称",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "share_total",
      "label": "分享数",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_total",
      "label": "点击数",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updated_date",
      "label": "更新时间",
      "width": "160"
    }
  })], 1), _vm._v(" "), (_vm.total_count > _vm.pageSize) ? _c('div', {
    staticClass: "content-padded tc"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.total_count,
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-20e72fc7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20e72fc7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/sharer/members/clicklist.vue
// module id = 2530
// module chunks = 0